import React, { useState } from 'react';
import DropdownList from './DropdownList';

const FileUploadForm = ({ onUpload }) => {
  const [file, setFile] = useState(null);
  const [documentType, setDocumentType] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleDocumentTypeChange = (event) => {
    setDocumentType(event.target.value);
  };

  const handleDocumentNumberChange = (event) => {
    setDocumentNumber(event.target.value);
  };

  const handleUpload = async (event) => {
    event.preventDefault();

    // Allow submission if either file OR document number is provided
    if (!file && !documentNumber.trim()) {
      alert('Please either upload a file or enter a registration number!');
      return;
    }

    onUpload({ file, documentType, documentNumber });
  };

  return (
    <form onSubmit={handleUpload}>
      <input type="file" onChange={handleFileChange} />
      <DropdownList
        value={documentType}
        onChange={handleDocumentTypeChange}
        label="Document Type"
      />
      <input
        type="text"
        placeholder="Enter Registration Number"
        value={documentNumber}
        onChange={handleDocumentNumberChange}
      />
      <button type="submit">Upload</button>
    </form>
  );
};

export default FileUploadForm;